module.exports = __webpack_public_path__ + "static/media/list-icon.df2e8f8d.svg";